import { render } from "./com_otros_movimientos.vue?vue&type=template&id=624a7ba6&scoped=true"
import script from "./com_otros_movimientos.vue?vue&type=script&lang=js"
export * from "./com_otros_movimientos.vue?vue&type=script&lang=js"

import "./com_otros_movimientos.vue?vue&type=style&index=0&id=624a7ba6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624a7ba6"]])

export default __exports__